// Section component for getting full-bleed background color
import styled from 'styled-components'

const FullWidthSection = styled.section`
  width: 100%;
  background-color: ${({ theme }) => theme.special};
  color: ${({ theme }) => theme.special3};
`

export default FullWidthSection
